import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { EComService } from "@src/app/ecom-services/ecom-common.service";
import { WindowRef } from '../../ecom-support-center/zoho-salesiq/WindowRef';
import $ from 'jquery';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DomSanitizer } from "@angular/platform-browser";
import { EComGoogleAnalytics } from "@src/app/ecom-services/ecom-google-analytics";

@Component({
    selector: 'app-ecom-contact-us',
    templateUrl: './ecom-contact-us.component.html',
    styleUrls: ['./ecom-contact-us.component.scss'],
    providers: [WindowRef]
})
export class EcomContactUsComponent implements OnInit {
    @Output() submitted: EventEmitter<any> = new EventEmitter();
    window: any;
    overlayDisplay = false;

    chatUrl: any;
    configChatPopup = {
        animated: true,
        class: 'modal-dialog-centered modal-lg',
        ignoreBackdropClick: true,
        keyboard: false
    };
    @ViewChild('chatbox', { static: true }) chatbox: ElementRef;
    modalRefChatbox: BsModalRef;
    constructor(private eComGoogleAnalytics: EComGoogleAnalytics, private modalService: BsModalService, public sanitizer: DomSanitizer, public ecomservice: EComService, private winRef: WindowRef) {
        this.window = winRef.nativeWindow;
    }
    // component initialize and load the required data
    ngOnInit() {
        let gTag = {
            'event': 'screen_view',
            'screen_name': 'contact-us'
        };
        this.eComGoogleAnalytics.customEvent(gTag);
    }

    overlayOpen() {
        this.overlayDisplay = true;
    }

    closeOverlay() {
        //this.overlayDisplay = false;
        this.submitted.emit('close');
    }

    onChatStartClick() {
        // this.overlayDisplay = false;
        // this.window && this.window.$zoho.salesiq.floatwindow.visible('show');
        this.chatUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://harishhg.3cx.in/callus/#harishhg');
        this.modalRefChatbox = this.modalService.show(this.chatbox, this.configChatPopup);
    }

    listYourRestaurantClick() {
        this.overlayDisplay = false;
        window.open(this.ecomservice.GetOlarConfigValue('merchantmate'), "_self");
    }

    // Method to handle the click event
    onCallClick(phonenumber) {
        document.location.href = 'tel:' + phonenumber;
    }

    onCloseChatClick() {
        this.modalRefChatbox.hide();
    }
}